import React, { FC, useCallback } from 'react';
import { Loader } from 'src/common/components/ListingItems';
import LoadingIcon from 'src/assets/icons/LoadingIcon';
import { CourseListingPaginationControl } from 'src/public/components/course-listing/CourseListingCourseTypeListPagination/CourseListingPaginationControl';
import { CourseListingResult } from 'src/public/components/course-listing/CourseListingResult';
import { CourseExcerpt } from 'src/common/models/courseExcerpt';
import { searchHeadingId, searchListPageSize } from 'src/config/listing';
import { CourseViewType } from 'src/state/courseListing/courseListingReducer';

export interface CourseListingPaginationProps {
  isLoading: boolean;
  noPageData: boolean;
  coursesData: CourseExcerpt[] | undefined;
  totalCourses: number;
  currentPage: number;
  setPage: (page: number) => void;
  viewType: CourseViewType;
}

export const CourseListingPagination: FC<CourseListingPaginationProps> = ({
  isLoading,
  noPageData,
  coursesData,
  totalCourses,
  currentPage,
  setPage,
  viewType,
}) => {
  const handlePageChange = useCallback(
    (page: number) => {
      document?.getElementById(searchHeadingId)?.scrollIntoView({
        behavior: 'smooth',
      });
      setPage(page);
    },
    [setPage],
  );

  return (
    <>
      {isLoading && (
        <Loader>
          <LoadingIcon size={64} />
        </Loader>
      )}

      {noPageData && (
        <p style={{ textAlign: 'center' }}>Brak szkoleń spełniających wybrane kryteria</p>
      )}

      {!isLoading && <CourseListingResult data={coursesData} viewType={viewType} />}

      {!noPageData && totalCourses > searchListPageSize && (
        <CourseListingPaginationControl
          currentPage={currentPage}
          pageSize={searchListPageSize}
          totalResult={totalCourses}
          handlePageChange={handlePageChange}
        />
      )}
    </>
  );
};
